import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const UserTreatmentsScheduleGrpcContractProvider: Provider = {
  provide: MainApi.UserTreatmentsScheduleGrpcContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.UserTreatmentsScheduleGrpcContractClient, 'mainApi'),
};
